import MainLayout from '@/layouts';

export default () => {
  return <MainLayout />;
};
